import React, { useEffect, useMemo } from 'react';
import {
  BUSINESS_TYPE_OPTIONS,
  getStarterCatalogRecommendation,
  normalizeBusinessType
} from '../../utils/businessTypeCatalog';

/**
 * Selector de tipo de comercio + opción de catálogo inicial recomendada.
 */
export default function BusinessTypeSelector({
  businessType,
  onBusinessTypeChange,
  shouldLoadStarterCatalog,
  onShouldLoadStarterCatalogChange,
  disabled = false,
  required = true,
  showCatalogOption = true,
  idPrefix = 'business-type',
  syncCatalogDefaultWithType = true
}) {
  const recommendation = useMemo(
    () => getStarterCatalogRecommendation(businessType),
    [businessType]
  );

  useEffect(() => {
    if (!syncCatalogDefaultWithType || !onShouldLoadStarterCatalogChange) return;
    if (!normalizeBusinessType(businessType)) return;
    onShouldLoadStarterCatalogChange(recommendation.defaultChecked);
  }, [businessType, recommendation.defaultChecked, syncCatalogDefaultWithType, onShouldLoadStarterCatalogChange]);

  return (
    <div className="space-y-3">
      <div>
        <label
          htmlFor={`${idPrefix}-select`}
          className="block text-xs font-semibold uppercase tracking-wide text-e0e3-muted mb-2"
        >
          Tipo de comercio {required ? '*' : ''}
        </label>
        <select
          id={`${idPrefix}-select`}
          className="nexo-field w-full"
          value={businessType || ''}
          disabled={disabled}
          required={required}
          onChange={(event) => onBusinessTypeChange?.(event.target.value)}
        >
          <option value="">Seleccioná un rubro…</option>
          {BUSINESS_TYPE_OPTIONS.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>

      {showCatalogOption && normalizeBusinessType(businessType) ? (
        <div className="rounded-xl border border-white/10 bg-white/[0.04] p-3">
          {recommendation.eligible ? (
            <label className="flex items-start gap-3 text-sm text-e0e3-foreground cursor-pointer">
              <input
                type="checkbox"
                className="mt-1 accent-e0e3-accent"
                checked={Boolean(shouldLoadStarterCatalog)}
                disabled={disabled}
                onChange={(event) => onShouldLoadStarterCatalogChange?.(event.target.checked)}
              />
              <span>
                <span className="font-semibold block">Cargar catálogo inicial de productos de consumo masivo</span>
                <span className="text-xs text-e0e3-muted block mt-1">{recommendation.message}</span>
              </span>
            </label>
          ) : (
            <p className="text-sm text-e0e3-muted">
              {businessType === 'distribuidora' ? (
                <>
                  <span className="font-semibold text-e0e3-foreground block">Crear catálogo vacío</span>
                  <span className="text-xs block mt-1">{recommendation.message}</span>
                </>
              ) : (
                recommendation.message
              )}
            </p>
          )}
        </div>
      ) : null}
    </div>
  );
}
